import { render, staticRenderFns } from "./FloatingStack.vue?vue&type=template&id=489a9d5d&scoped=true"
import script from "./FloatingStack.vue?vue&type=script&lang=js"
export * from "./FloatingStack.vue?vue&type=script&lang=js"
import style0 from "./FloatingStack.vue?vue&type=style&index=0&id=489a9d5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a9d5d",
  null
  
)

export default component.exports